import React from 'react';
import { Container, Row, Col, Card, Button, ListGroup } from 'react-bootstrap';

const Pricing = () => {
  const plans = [
    {
      id: 1,
      name: 'Basic',
      price: '$29',
      period: '/month',
      description: 'Perfect for individuals getting started',
      features: [
        'Access to basic courses',
        'Community support',
        'Certificate of completion',
        'Mobile app access',
      ],
      popular: false,
    },
    {
      id: 2,
      name: 'Professional',
      price: '$79',
      period: '/month',
      description: 'Best for professionals and teams',
      features: [
        'Access to all courses',
        'Priority support',
        'Advanced certificates',
        'Mobile app access',
        'Live Q&A sessions',
        'Project reviews',
      ],
      popular: true,
    },
    {
      id: 3,
      name: 'Enterprise',
      price: '$199',
      period: '/month',
      description: 'For large organizations',
      features: [
        'Everything in Professional',
        'Custom training programs',
        'Dedicated account manager',
        'API access',
        'Custom integrations',
        'Advanced analytics',
      ],
      popular: false,
    },
  ];

  return (
    <Container fluid>
      <Row className="g-3 mb-4">
        <Col>
          <div className="text-center">
            <h2 className="mb-2">Choose Your Plan</h2>
            <p className="text-body-secondary">
              Select the perfect plan for your learning journey
            </p>
          </div>
        </Col>
      </Row>
      <Row className="g-3 justify-content-center">
        {plans.map((plan) => (
          <Col key={plan.id} md={6} lg={4}>
            <Card
              className={`h-100 ${
                plan.popular ? 'border-primary shadow-lg' : ''
              }`}
            >
              {plan.popular && (
                <div className="position-absolute top-0 start-50 translate-middle">
                  <span className="badge bg-primary rounded-pill px-3 py-2">
                    Most Popular
                  </span>
                </div>
              )}
              <Card.Header className="text-center pt-4">
                <h5 className="mb-1">{plan.name}</h5>
                <div className="mb-2">
                  <span className="display-6 fw-bold text-primary">
                    {plan.price}
                  </span>
                  <span className="text-body-secondary">{plan.period}</span>
                </div>
                <p className="text-body-secondary small mb-0">
                  {plan.description}
                </p>
              </Card.Header>
              <Card.Body className="pt-3">
                <ListGroup variant="flush" className="mb-4">
                  {plan.features.map((feature, index) => (
                    <ListGroup.Item key={index} className="border-0 px-0 py-2">
                      <div className="d-flex align-items-center">
                        <span className="text-success me-2">✓</span>
                        <span className="small">{feature}</span>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
                <Button
                  variant={plan.popular ? 'primary' : 'outline-primary'}
                  className="w-100"
                  size="lg"
                >
                  Get Started
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Pricing;
